export const ErrorMessages = {
  loginFailed: 'Login failed. Please check your credentials.',
  logoutFailed: 'Logout failed. Please try again later.',
  default: 'Something went wrong. Please try again later.',
  emptyInputField:'Enter a value',
  serviceLevel: {
    formErrors: 'Enter a value',
    days_Supported: 'Enter a valid value',
    time_Supported: 'Enter a valid time',
  },
  oosBillSets:{
    emptyInputField:'Enter a value',
    formEnterErrors: 'Enter a value',
    formSelectErrors: 'Select a value',
    formNumberErrors: 'Enter a number',
    formTimeErrors: 'Enter a time',
    formIvalidFormatErrors: 'Incorrect format',
  },
  contract:{
    emptyInputField:'Enter a value'
  },
  siteEntitlement:{
    serviceProductlId:'Please select Service Product',
    startDate:'Please select a Start Date',
    duration:'Please select Duration',
    serviceLevelId:"Please select Service Level",
    currencyId:"Please select Currency Id"
  },
  eTracSetting:{
    eterValidDays: 'Please enter valid days',
  },
};
